<template>
  <v-breadcrumbs class="px-0 py-3"
                 :items="breadcrumbs">
  </v-breadcrumbs>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    }
  },
  computed: {
    breadcrumbs() {
      let crumbs = [
        {text: 'Content Library', exact: true, to: {name: 'presentations'}},
      ];
      this.items.forEach(item => {
        crumbs.push(item);
      })
      return crumbs;
    }
  }
}
</script>
